import { STORE_SELECTED } from '../actions/actionTypes';

const initialState = {
  selectedStoreName: ''
};

const storeReducer = (state = initialState, action) => {
  switch (action.type) {
    case STORE_SELECTED:
      return {
        ...state,
        selectedStoreName: action.payload
      };
    default:
      return state;
  }
};

export default storeReducer; 